import { render } from "./VetDashboard.vue?vue&type=template&id=62cfa5a7&scoped=true"
import script from "./VetDashboard.vue?vue&type=script&lang=js"
export * from "./VetDashboard.vue?vue&type=script&lang=js"

import "./VetDashboard.vue?vue&type=style&index=0&id=62cfa5a7&lang=css"
import "./VetDashboard.vue?vue&type=style&index=1&id=62cfa5a7&scoped=true&lang=css"

import exportComponent from "/Applications/PROJECTS/FLOCKR/FLOCKER-PORTAL/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-62cfa5a7"]])

export default __exports__